import { trigger, transition, style, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertType } from '@core/type/alert.type';
import { IconAlertErrorComponent } from '@shared/design/atoms/icons/icon-alert-error.component';
import { IconAlertSuccessComponent } from '@shared/design/atoms/icons/icon-alert-success.component';
import { IconAlertWarningComponent } from '@shared/design/atoms/icons/icon-alert-warning.component';
import { IconWrapperComponent } from '@shared/design/molecules/icon-wrapper/icon-wrapper.component';
import { LabelModalSubtitleComponent } from '@shared/design/atoms/text/label-modal-subtitle.component';
import { LabelModalTitleComponent } from '@shared/design/atoms/text/label-modal-title.component';
import { ButtonComponent } from '@shared/design/molecules/button/button.component';

@Component({
    selector: 'app-modal-alert',
    imports: [
    IconWrapperComponent,
        CommonModule,
        IconAlertErrorComponent,
        IconAlertSuccessComponent,
        IconAlertWarningComponent,
        LabelModalSubtitleComponent,
        LabelModalTitleComponent,
        ButtonComponent,
    ],
    templateUrl: './modal-alert.component.html',
    styleUrl: './modal-alert.component.scss',
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [animate('200ms', style({ opacity: 0 }))]),
        ]),
    ]
})
export class ModalAlertComponent {
  isVisible: boolean = false;
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() type!: AlertType;
  @Input() acceptLabel!: string;
  @Input() rejectLabel!: string;
  @Input() showAccept: boolean = true;
  @Input() showReject: boolean = true;
  @Input() isLoading: boolean = false;
  @Output() onAccept = new EventEmitter<void>();
  @Output() onReject = new EventEmitter<void>();

  openModal() {
    this.isVisible = true;
  }

  closeModal() {
    this.isVisible = false;
  }
}
